import store from '@/store';
import router from '@/router';
import AuthService from '@/services/auth/AuthService';
import AuthRedirectService from '@/services/auth/AuthRedirectService';

export default class RedirectAfterAccessTokenExpiration {
    authService

    constructor() {
        this.authService = new AuthService();
    }

    /**
     * Redirect to the refresh page or the logout page after an access token expiration.
     *
     * @returns {void}
     */
    handle() {
        if (store.getters['auth/isRefreshProcessing']) {
            return;
        }

        if (store.getters['auth/getRefreshTokenAttempts'] < 3) {
            store.commit('auth/updateRefreshProcessing', true);
            store.commit('auth/updateIntendedUrl', router.currentRoute.path);

            this.refreshToken();
        } else {
            store.dispatch('auth/logout');

            router.push({ name: 'logout' });
        }
    }

    /**
     * Handles the refresh token error response.
     *
     * @returns {void}
     */
    handleRefreshTokenErrorResponse() {
        AuthRedirectService.redirectToLoginPage();
    }

    /**
     * Handles the refresh token success response.
     *
     * @returns {void}
     */
    handleRefreshTokenSuccessResponse() {
        store.dispatch('auth/loginUser', store.getters['auth/getUserType']);

        this.redirectToIntendedUrl();
    }

    /**
     * Redirects to intended URL.
     *
     * @returns {void}
     */
    redirectToIntendedUrl() {
        router.push(store.getters['auth/isUserLoggedIn']);
    }

    /**
     * Refresh canvasser's access token.
     *
     * @returns {void}
     */
    refreshCanvasserToken() {
        this.authService.refreshCanvasser()
            .then(() => this.handleRefreshTokenSuccessResponse())
            .catch(() => this.handleRefreshTokenErrorResponse());
    }

    /**
     * Refresh customer's access token.
     *
     * @returns {void}
     */
    refreshCustomerToken() {
        this.authService.refresh()
            .then(() => this.handleRefreshTokenSuccessResponse())
            .catch(() => this.handleRefreshTokenErrorResponse());
    }

    /**
     * Refresh access token.
     *
     * @returns {void}
     */
    refreshToken() {
        if (store.getters['auth/isCanvasser']) {
            this.refreshCanvasserToken();
        } else {
            this.refreshCustomerToken();
        }
    }
}
